import moment from "moment";

class DateUtils {
    static figureOutValidityDate = (validFrom, validTo) => {
        const currentDate = new Date();
        if (!validFrom || !validTo) {
            return currentDate
        }

        const momentCurrentDate = moment(currentDate, "YYYY-MM-DD")
        const momentValidFrom = moment(validFrom, "YYYY-MM-DD")
        const momentvalidTo = moment(validTo, "YYYY-MM-DD")

        if (momentCurrentDate.isSameOrAfter(momentValidFrom) && momentCurrentDate.isSameOrBefore(momentvalidTo)) {
            return momentCurrentDate;
        }
        if (momentCurrentDate.isBefore(momentValidFrom)) {
            return momentValidFrom;
        }
        if (momentCurrentDate.isAfter(momentvalidTo)) {
            return momentvalidTo;
        }

        return momentCurrentDate;
    }
}

export default DateUtils;